import Controller from '@ember/controller';
import { service } from '@ember/service';
import type LocationModel from 'garaje/models/location';
import type CurrentAdminService from 'garaje/services/current-admin';
import type CurrentLocationService from 'garaje/services/current-location';
import type GlobalSettingBatchService from 'garaje/services/global-setting-batch';
import { alias } from 'macro-decorators';

import type FinalScreenRouteModel from './route';

export default class VisitorsSettingsVisitorTypesFlowFinalScreenController extends Controller {
  declare model: FinalScreenRouteModel;

  @service('global-setting-batch') declare globalSettingBatchService: GlobalSettingBatchService;
  @service declare currentAdmin: CurrentAdminService;
  @service declare currentLocation: CurrentLocationService;

  isEditingCustomFinalMessage = false;
  messageType = '';

  @alias('globalSettingBatchService.currentGlobalSettingBatch')
  declare globalSettingBatch: GlobalSettingBatchService['currentGlobalSettingBatch'];
  @alias('currentLocation.languagesAvailable')
  declare translationLanguagesAvailable: LocationModel['languagesAvailable']; // boolean

  get translationEnabledLocales(): LocationModel['enabledLocales'] {
    const enabledLocales = this.currentLocation.content?.enabledLocales || [];
    const locale = this.currentLocation.content?.locale || 'en';

    return Array.from(new Set([...enabledLocales, locale]));
  }
}
